<ion-row class="wrapper">
  <ion-col size="12" *ngIf="title" [ngClass]="{ 'center': alignment === InfoAlignment.center}"><h5>{{ title }}</h5></ion-col>
  <ion-col size="12" *ngIf="message" [ngClass]="{ 'center': alignment === InfoAlignment.center}">
    <p class="text-default-normal" *ngIf="infoType !== InfoTypes.innerHTML">{{ message }}</p>
    <p class="text-default-normal" *ngIf="infoType === InfoTypes.innerHTML" [innerHTML]="message"></p>
  </ion-col>
</ion-row>
